import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "./util";
import { feedApiKey } from "./ApiKey/FeedApiKey";

export const getFeed = ({ setFeeds }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/feed",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      setFeeds(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addFeedLike = ({ feed_id, triggerInvalidate }) => {
  const { createdLikedFeed } = feedApiKey;
  var config = {
    method: "post",
    url: baseUrl + "/api/business/feed/like",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      feed_id: feed_id,
    },
  };
  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      triggerInvalidate(createdLikedFeed);
    })
    .catch(function (error) {
      let errorMessage =
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "An unexpected error occurred";

      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: errorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const getFeedLike = ({ setFeedsLike }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/feed/like",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      setFeedsLike(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteFeedLike = ({ id, triggerInvalidate }) => {
  const { deleteLikedFeed } = feedApiKey;
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/feed/like/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      triggerInvalidate(deleteLikedFeed);
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const addRecentlyViewedFeed = ({ feed_id, triggerInvalidate }) => {
  const { createRecentlyViewedFeed } = feedApiKey;
  var config = {
    method: "post",
    url: baseUrl + "/api/business/feed/recently-viewed",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      feed_id: feed_id,
    },
  };
  axios(config)
    .then(function (response) {
      triggerInvalidate(createRecentlyViewedFeed);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getRecentlyViewedFeed = ({ setRecentlyViewedFeeds }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/feed/recently-viewed",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      setRecentlyViewedFeeds(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteRecentlyViewedFeed = ({ id, triggerInvalidate }) => {
  const { deleteFeedRecentlyViewed } = feedApiKey;
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/feed/recently-viewed/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      triggerInvalidate(deleteFeedRecentlyViewed);
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};
